import { useEffect, useState } from 'react';
import { fetchGroupMemberModalData } from './memberModalApiUtils';

const EMPTY_ARRAY = [];

const toArray = (value) => (Array.isArray(value) ? value : EMPTY_ARRAY);

export default function useGroupMemberModalData({
  open = false,
  enabled = true,
  apiUrl = '',
  groupThreadId = '',
  partsList = null,
  mode = 'artist',
  resource = 'thread',
  resetOnDisable = false,
  resetOnClose = false,
  errorLabel = 'group member list fetch error',
}) {
  const [loading, setLoading] = useState(false);
  const [parts, setParts] = useState(() => toArray(partsList));
  const [thread, setThread] = useState(null);

  useEffect(() => {
    if (Array.isArray(partsList) && partsList.length > 0) {
      setParts(partsList);
    }
  }, [partsList]);

  useEffect(() => {
    const shouldReset = (!enabled && resetOnDisable) || (!open && resetOnClose);
    if (shouldReset) {
      setThread(null);
    }

    if (!open || !enabled || !apiUrl || !groupThreadId) {
      if (!open || !enabled) {
        setLoading(false);
      }
      return undefined;
    }

    let active = true;
    (async () => {
      setLoading(true);
      try {
        const { parts: nextParts, thread: nextThread } = await fetchGroupMemberModalData({
          apiUrl,
          groupThreadId,
          partsList,
          mode,
          resource,
        });
        if (!active) return;
        setParts(nextParts);
        setThread(nextThread);
      } catch (error) {
        console.error(`${errorLabel}:`, error);
        if (!active) return;
        setThread(null);
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [
    apiUrl,
    enabled,
    errorLabel,
    groupThreadId,
    mode,
    open,
    partsList,
    resource,
    resetOnClose,
    resetOnDisable,
  ]);

  return {
    loading,
    parts,
    thread,
    setParts,
    setThread,
  };
}
